export function setLog(description,date,userId,moduleName,buttonName,screen) {
    return fetch('https://mandulisfleetapi.azurewebsites.net/api/services/app/Log/Create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({          
        description: description,
        date: date,
        userId: userId,
        moduleName: moduleName,
        buttonName:buttonName,
        screen: screen,           
    } )
    })
      .then(data => data.json())
   }
